import {Component, OnInit} from '@angular/core';
import {SectionComponent} from '../elements/section/section.component';
import {TextsComponent} from '../elements/texts/texts.component';
import {text} from "../../functions/localization";
import {RunningLineComponent} from '../elements/running-line/running-line.component';
import {ThemeService} from '../../services/theme.service';
import {Text} from '../../model/text';
import {NgIf} from '@angular/common';
import {FooterService} from '../../services/footer-service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-footer',
  imports: [
    SectionComponent,
    TextsComponent,
    RunningLineComponent,
    NgIf
  ],
  templateUrl: './footer.component.html',
  standalone: true,
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit{
  constructor(public themeService: ThemeService,
              public footerService: FooterService) {}

  mob: boolean = false;

  topRight: Text[] = [
    {text: ['+66 99 160 97 11', '+66 99 160 97 11']}
  ];
  botRight: Text[] = [
    {text: ['IATA TIDS 96223466', 'IATA TIDS 96223466']}
  ];

  midRight1: Text[] = [
    {text: ['Политика использования куки', 'Cookie Policy']}
  ];
  midRight2: Text[] = [
    {text: ['Политика конфиденциальности', 'Privacy Policy']}
  ];
  midRight3: Text[] = [
    {text: ['Публичная оферта', 'Public Offer']}
  ];

  ngOnInit() {
    if (window.innerWidth < 769) {
      this.topRight = [
        {text: ['BR № 77889104\n' +
          'IATA TIDS 96223466', 'BR № 77889104\n' +
          'IATA TIDS 96223466']}
      ];
      this.botRight = [
        {text: ['+66 99 160 97 11', '+66 99 160 97 11']}
      ];
      this.midRight1 = [
        {text: ['Куки', 'Cookie Policy']}
      ];
      this.midRight2 = [
        {text: ['Приватность', 'Privacy Policy']}
      ];
      this.midRight3 = [
        {text: ['Оферта', 'Public Offer']}
      ];
    }
    if (window.innerWidth < 577) {
      this.mob = true;
      this.botRight = [
        {text: ['BR № 77889104\n' +
          'IATA TIDS 96223466', 'BR № 77889104\n' +
          'IATA TIDS 96223466']}
      ];
    }
  }

  getImg() {
    if (this.footerService.getFooterImage() === '') {
      return 'app/assets/images/footer-sky.svg'
    } else return environment.s3Prefix + this.footerService.getFooterImage()
  }

  // up() {
  //   scrollUp();
  // }

  openWhatsApp(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const phoneNumber = '+66991609711';
    const message = 'тест';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank');
  }

  openTelegram(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const username = 'ilovefirstclass';
    const message = 'тест';
    const url = `https://t.me/${username}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank');
  }

  openPhoneCall(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const phoneNumber = '+66991609711';
    const url = `tel:${phoneNumber}`;

    window.open(url, '_blank');
  }

  openInstagramProfile(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const username = 'ilovefirstclass';
    const url = `https://www.instagram.com/${username}/`;

    window.open(url, '_blank');
  }

  multiOpen(tab: boolean, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    if (tab) {
      if (window.innerWidth < 769) {
        this.openPhoneCall(event);
      }
    } else if (window.innerWidth > 769) {
      this.openPhoneCall(event);
    }
  }

  openPdfInNewTab(url: string, event?: Event){
    if (event) {
      event.stopPropagation();
    }
    const x = 'app/assets/pdf/new/';
    let y = ''
    switch (url) {
      case 'cookie': {
        y = 'Cookie Policy'
        break;
      }
      case 'privacy': {
        y = 'Privacy Policy'
        break;
      }
      case 'public': {
        y = 'Public Offer'
        break;
      }
      default: {
        return
      }
    }
    window.open(x + y + '.pdf', '_blank', 'noopener,noreferrer');
  }

  getBackground() {
    return this.footerService.getFooterColor()
  }

  protected readonly text = text;
}
